// extracted by mini-css-extract-plugin
export default {"ou":"page_ou__5HQpt"};